import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { dateReviver } from '../utils/date-reviver';
import { map } from 'rxjs';

export const JsonDateInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    map(response => {
      if (
        response instanceof HttpResponse &&
        response.body &&
        response.headers.get('content-type')?.includes('application/json')
      ) {
        return response.clone({
          body: JSON.parse(JSON.stringify(response.body), dateReviver),
        });
      }
      return response;
    })
  );
};
